import React from 'react'

export default function HorizontalDivider() {
    return (
        <div className='w-full px-2 my-3 border-b'></div>
    )
}
